import styled from 'styled-components';

export const ScJackpotPage = styled.div`
  position: relative;

  .page-content {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    gap: 64px;
  }
`;
